import { render, staticRenderFns } from "./InboxList.vue?vue&type=template&id=c0c1072a"
import script from "./InboxList.vue?vue&type=script&lang=js"
export * from "./InboxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports